module.exports = __webpack_public_path__ + "img/logo-SCB.e4c2c2b.png";